import "@stripe/stripe-js";
export default function Stripe() {
  return <></>;
}
